<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>财务管理</el-breadcrumb-item>
			<el-breadcrumb-item>财务流水</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="账目类型">
				<el-select v-model="item.type" placeholder="账目类型" size="small">
					<el-option label="分销佣金" value=""></el-option>
					<el-option label="充值" value=""></el-option>
					<el-option label="零售" value=""></el-option>
					<el-option label="期初调整" value=""></el-option>
					<el-option label="采购退货" value=""></el-option>
					<el-option label="采购支出" value=""></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="datetimerange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
				<el-button type="success" @click="excelOut" size="medium">导出</el-button>
			</el-form-item>
		</el-form>
		<!--		数据是list 通过list展示-->
		<el-table :data="list" border>
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="type" label="账目类型"></el-table-column>
			<el-table-column prop="fee" label="金额"></el-table-column>
			<el-table-column prop="date" label="创建日期"></el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [{
					id: 1,
					number: 1,
					type: "采购支出",
					fee: '100.00',
					date: "2021-07-01 17:24:28"
				}, {
					id: 2,
					number: 2,
					fee: "20.00",
					type: '采购退货',
					status: '审核通过',
					date: "2021-07-01 17:24:28"
				}, {
					id: 3,
					number: 3,
					fee: "100.00",
					name: '陈',
					type: '采购支出',
					status: '待审核',
					date: "2021-07-01 17:24:28"
				}],
				isLoad: false,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {}
			}
		},
		created() {
			this.item = {
				page: this.page,
				limit: this.pageSize
			}
			// this.loadList()
		},
		methods: {
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/store/list', {})
					.then(res => {
						this.isLoad = !this.isLoad
						// 获取数据
						this.list = res.data.records
						// 页数 page
						this.total = res.data.total
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			// 跳转到edit添加
			add() {
				return
				this.$router.push({
					path: '/Member/MemberLevelEdit.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				return;
				this.$router.push({
					path: '/Member/MemberLevelEdit.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.item.pageSize = val
				//   this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				//   this.loadList()
			},
			// 搜索查询
			submit() {
				console.log(this.value2);
				return
				this.item.page = 1
				//   this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
